/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useState } from 'react';

// react-select with props typescript types
import Select, { ActionMeta } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { customStyles } from './style';

export interface OptionProps {
  value?: string | number | undefined;
  label: string | number | undefined;
  target?: HTMLInputElement;
}

export interface SelectAutoCompleteProps {
  name: string;
  label?: any;
  error?: any;
  onChange?: (newValue: any, actionMeta?: ActionMeta<OptionProps>) => void;
  value: any;
  options: OptionProps[] | undefined;
  placeholder?: string;
  id?: string;
  style?: React.CSSProperties;
  wrapperClass?: string;
  className?: string;
  control?: any;
  defaultValue?: OptionProps;
  onBlur?: () => void;
  refSelect?: any;
  disabled?: boolean;
  isClearable?: boolean;
  isMulti?: boolean;
  isCreatable?: boolean;
  isSearchable?: boolean;
  noOptionsMessage?: () => string;
  formatCreateLabel?: (inputValue: string) => React.ReactNode;
}

export const SelectCustom = (props: SelectAutoCompleteProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onMenuOpen = () => setIsMenuOpen(true);
  const onMenuClose = () => setIsMenuOpen(false);

  const Component = (props.isCreatable ? CreatableSelect : Select) as any;

  const getValue = () => {
    if (props.isMulti) {
      if (!props.value) return [];
      if (Array.isArray(props.value)) {
        return props.value.map(val => {
          const found = props?.options?.find((option: OptionProps) => option.value === val);
          return found || { label: String(val), value: val };
        });
      }
      return [];
    }

    if (props.value === undefined || props.value === null || props.value === '') {
      return null;
    }

    const found = props?.options?.find((option: OptionProps) => option.value === props.value);
    if (found) return found;

    if (props.isCreatable) {
      return { label: String(props.value), value: props.value };
    }

    return null;
  };

  return (
    <>
      <div
        className={`flex-column input-component ${props.wrapperClass || ''} ${
          props.disabled ? 'input-disabled' : ''
        } ${props.error ? 'input-error' : ''}`}
      >
        {props.label && (
          <label htmlFor={props.name} className="input-label">
            {props.label}
          </label>
        )}
        <Component
          options={props.options}
          placeholder={props.placeholder}
          onChange={props.onChange}
          onBlur={props.onBlur}
          onMenuOpen={onMenuOpen}
          onMenuClose={onMenuClose}
          styles={{
            ...customStyles(props),
            menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
          }}
          menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
          className={props.className}
          noOptionsMessage={props.noOptionsMessage || (() => 'Nenhum resultado encontrado')}
          formatCreateLabel={
            props.formatCreateLabel || ((inputValue: string) => `Pesquisar "${inputValue}"`)
          }
          value={getValue()}
          defaultValue={props.defaultValue}
          ref={props.refSelect}
          isDisabled={props.disabled}
          isClearable={props.isClearable}
          isMulti={props.isMulti}
          isSearchable={props.isSearchable ?? true}
        />
        {props.error && (
          <span role="alert" className="alert-error">
            {props.error}
          </span>
        )}
      </div>
    </>
  );
};
